export const storePages = {
    storeClickProduct: {
        rbmail: {
            type: 'click',
            id: '72009592',
        },
    },
    storeClickMainProduct: {
        rbmail: {
            type: 'click',
            id: '72009572',
        },
    },
    storeClickSecondMainProduct: {
        rbmail: {
            type: 'click',
            id: '72009578',
        },
    },
    storeClickOzonLogo: {
        rbmail: {
            type: 'click',
            id: '72009578',
        },
    },
    storeMainPageAskQuestion: {
        rbmail: {
            type: 'click',
            id: '68061962',
        },
    },
    storePixelMainEnter: 'id=2958944;e=RG%3A/trg-pixel-9837476-1600428626003;',
    storePixelClickBuy: 'id=2958944;e=RG%3A/trg-pixel-9837476-1600428694195;',
};
